import { Cell, Grid, InfoLabel } from 'bold-ui'
import React from 'react'

import { AtividadeColetivaGruposModel, atividadeColetivaTipoGrupoRecord } from './model-atividadeColetivaGrupos'

interface AtividadeColetivaGruposInfoHeaderProps {
  atividadeColetivaGrupo: AtividadeColetivaGruposModel
}

export const AtividadeColetivaGruposInfoHeader = (props: AtividadeColetivaGruposInfoHeaderProps) => {
  const { atividadeColetivaGrupo } = props

  return (
    <Grid gap={2}>
      <Cell size={3}>
        <InfoLabel title='Nome do grupo'>{atividadeColetivaGrupo.nome}</InfoLabel>
      </Cell>
      <Cell size={3}>
        <InfoLabel title='Unidade de saúde'>{atividadeColetivaGrupo.unidadeSaude.nome}</InfoLabel>
      </Cell>
      <Cell size={3}>
        <InfoLabel title='Tipo de grupo'>
          {atividadeColetivaTipoGrupoRecord[atividadeColetivaGrupo.tipoGrupo]}
        </InfoLabel>
      </Cell>
      <Cell size={3}>
        <InfoLabel title='Nº de participantes'>{atividadeColetivaGrupo.quantidadeCidadaosParticipantes}</InfoLabel>
      </Cell>
    </Grid>
  )
}
